"use client";

import { sendGTMEvent } from "@next/third-parties/google";
import { useHydrated, useSupabaseUser } from "@utils/hooks";
import { useEffect, useState } from "react";

// used in whitelabel to only use clarity when consent is given via cookiebot
export default function ClarityTrackerWithConsent() {
  const hydrated = useHydrated();
  const user = useSupabaseUser();
  const [isConsented, setIsConsented] = useState(false);

  useEffect(() => {
    const handleCookiebotChange = (e: any) => {
      const consentedToStatistics =
        e?.target?.CookieConsent?.consent?.statistics;
      setIsConsented(consentedToStatistics);

      if (window?.clarity) {
        if (consentedToStatistics) {
          window.clarity("consent");
        } else {
          window.clarity("consent", false);
        }
      }
    };

    if (hydrated) {
      window.addEventListener("CookiebotOnDecline", handleCookiebotChange);
      window.addEventListener("CookiebotOnAccept", handleCookiebotChange);
    }

    return () => {
      window.removeEventListener("CookiebotOnDecline", handleCookiebotChange);
      window.removeEventListener("CookiebotOnAccept", handleCookiebotChange);
    };
  }, [hydrated]);

  useEffect(() => {
    if (hydrated && user && isConsented) {
      sendGTMEvent({
        event: "clarity",
        userUid: user.app_metadata.iticket_user_uid,
      });
    }
  }, [hydrated, user, isConsented]);

  return null;
}
